<template>
  <div class="manage-main">
    <div class="manage-title">模块管理</div>
    <div class="manage-position">
      <div class="menu" style="cursor: auto!important;">
        <div class="title">基本信息</div>
      </div>
      <div class="menu" style="cursor: auto!important;" v-if="cvDetail.basic_info.school_logo_url">
        <div class="title">校徽</div>
        <div class="operation">
          <i class="iconfont delete icontrash-" @click="deleteSchoolLogo"></i>
        </div>
      </div>
      <draggable v-model="listMenu" @change="positionChange" :options="{ animation: 200, ghostClass: 'ghost'}">
        <div class="menu" v-for="(item, index) in listMenu" :key="index">
          <div class="title text-overflow">{{item.title}}</div>
          <div class="operation">
            <i class="iconfont delete icontrash-" @click.stop="deleteModule(item, index)"></i>
            <i class="iconfont iconmove"></i>
          </div>
        </div>
      </draggable>
    </div>

    <div class="manage-title margin-top-36" v-if="moduleList.length">添加模块
      <img v-show="showManageAddGuide" class="manage-img" src="https://files.wondercv.com/pc/editor/manage.png" width="182"/>
    </div>
    <div class="main">
      <template v-for="(item, index) in moduleList">
        <div class="module" :key="index" @click="addModule(item)" v-if="!((item.type==='school' || item.type==='custom' || item.type==='opus') && isMentorEditor) " >
          <div class="info">
            <i :class="['iconfont', item.iconfont]"></i>
            <div class="text">
              <div class="name">{{item.name}}</div>
              <div class="msg text-overflow">{{item.placeholder}}</div>
            </div>
          </div>
          <!-- <div
            class="recover"
            v-if="isRecover(item)"
            @click.stop="recoverModule(item, index)">
            <div class="recover-msg">
              恢复
            </div>
            <i class="iconfont iconrotate-cw"></i>
          </div> -->
        </div>
      </template>
    </div>
  </div>
</template>
<script>
  import { mapState, mapMutations, mapActions } from 'vuex';
  import draggable from 'vuedraggable';
  import { dealSignatrue } from '@/assets/js/util';
  import api from '@/api';
  import { menu } from '@/assets/js/manage';
  import { dealResumeDomScroll } from '../../../../../assets/js/util'

  export default {
    name: 'Manage',
    components: {
      draggable
    },
    data() {
      return {
        menu, // 模块总列表
        listMenu: [], // 现有的模块
        removeList: [], // 删除的模块
        // moduleList: [], // 可添加的模块
        extrasList:['certificate', 'interest', 'language', 'other', 'skill' ], //其他模块标题
      }
    },
    computed: {
      ...mapState('cvs', ['cvs', 'cv', 'cvPages', 'downloadCv', 'editCheckData', 'editorCvToken']),
      ...mapState('cvsEditor', ['cvInfo', 'list', 'editModuleData']),

      ...mapState('editor', ['cvToken', 'cvDetail', 'currentInfo',]),
      ...mapState('manage', ['menuList', 'editModuleData', 'moduleList', 'reloadMenuList']),
      ...mapState('experience', ['backUpExperienceList', 'experienceList', 'currentExperienceType', 'experienceTitleList', 'showManageAddGuide']),
      isMentorEditor () {
        return window.location.href.includes('mentor')
      }
    },
    created() {
      this.listMenu = JSON.parse(JSON.stringify(this.menuList))
      // 获取已经未选中的模块
      this.getFilterModule();
    },
    watch:{
      menuList: function (val) {
        this.listMenu = JSON.parse(JSON.stringify(this.menuList))
      }
    },
    methods: {
      ...mapMutations('editor',['setCvDetail', 'setModuleData', 'setCurrentInfo', 'updateCommonIndex']),
      ...mapMutations('experience',['updateExperienceList', 'updateBackUpExperienceList', 'updateSidebarOption']),
      ...mapMutations('manage',['setReloadMenuList', 'setMenuList', 'setFilterModule']),
      ...mapActions('manage',['getMenuList', 'getFilterModule']),
      ...mapActions('editor',['updateCvDetail', 'createCvDetail']),

      // 修改排序更改
      async positionChange() {
        let cvDetail = JSON.parse(JSON.stringify(this.cvDetail));
        let sections_position = [];

        this.listMenu.forEach(item=>{
          sections_position.push(item.sections_position)
        })
        cvDetail.submodule_info.sections_position = sections_position;

        try {
          let data = {
            operation_type:'update_submodule_info',
            submodule_info: cvDetail.submodule_info
          }
          let res = {}
          if (this.cvDetail.basic_info.kind) {
            this.setMenuList(this.listMenu)
            this.setCvDetail(cvDetail)
          } else  {
            if (this.isMentorEditor) {
              res = await api.cvsEditor.updatedMentorCvInfo(this.cvToken, data)
            } else {
              res = await api.cvsEditor.updatedCvInfo(this.cvToken, data);
            }
            if (res.code === 1000) {
              //同步顺序
              this.setCvDetail(cvDetail)
              this.$message.success('更新成功');
              //同步顺序到模块管理
              this.setMenuList(this.listMenu)
            } else {
              this.$message.error(res.message);
            }
          }
        } catch (error) {
          console.log('error=>>',error)
          this.$message.error('更新失败');
        }

      },

      // 添加模块-检测类型及提示
      addModule(data) {
        if (data.type === 'school') {
          let { kind } = this.cvDetail.basic_info
          //检测是否有profile数据
          // if ( kind ==='template' || kind ==='sample' ) {
          // 	this.$message.error('请先完善简历信息')
          // } else {
          this.$store.dispatch('app/setAlertData', { show: true, type: 'school' });
          // }
          return false;
        }
        if (this.currentInfo.operation) {
          const alertData = {
            show: true,
            type: 'message',
            messageTitle: '添加模块提示',
            showCancelButton: true, //取消按钮
            showConfirmButton: true, // 确定按钮
            confirmButtonText: '取消',
            cancelButtonText: '确认',
            cancelButtonClass: 'cvs-edit-cancelButtonClass',
            confirmButtonClass: 'cvs-edit-confirmButtonClass',
            messageContent: `
            <p>当前模块还未完善，是否继续</p>
          `,
            confirm: close => {
              close();
            },
            cancel: async close => {
              close();
              this.addModuleNext(data);
            }
          };
          this.$store.dispatch('app/setAlertData', alertData);
          return false;
        }
        this.addModuleNext(data);
      },

      /**
       * @function 创建自定义模块
       * @param category: 代表创建的是哪个类型的模块, section_title: 创建的大模块名称
       * @returns 自定义模块的 id
       */
      async createCustomSection(category, section_title) {
        try {
          const res = await api.cvsEditor.createCustom({
            category,
            section_title,
            lang: this.cvDetail.basic_info.lang || 'cn',
            cv_token: this.cvToken
          });
          if (res.code === 1000) {
            // 创建大的自定义模块的时候会相应的创建一个info_id的脏数据，但是不能清除， 目前经历库维护的数据结构有经历的话才能拿到模块id
            const { custom_section: { id, infos } } = res.data;
            // copy 经历库数据，将新建的自定义模块加进去
            let experienceList = JSON.parse(JSON.stringify(this.experienceList));
            experienceList[id] = infos;

            this.updateExperienceList(experienceList);
            return id;
          }
        } catch (error) {
          console.log(error);
        }
      },

      // 添加模块-整理数据
      async addModuleNext(data) {
        let { lang = 'cn', kind } = this.cvDetail.basic_info;
        let {  submodule_info } = this.cvDetail;
        const baseField = [ 'edus', 'works', 'orgs', 'extras', 'opus'];
        // 自定义模块的 id
        let customSectionId = null;
        let moduleInfo = {};
        // 从简历的section_position中把自定义模块挑出来，判断是否自定义模块是否超过5个的限制
        const customSection = submodule_info.sections_position.filter(item => item.type === 'custom');

        if (customSection.length > 5) {
          this.$message("自定模块最多添加6个");
          return;
        }

        if (data.type === 'custom') {
          // type 为自定义模块的时候，需要创建大模块，然后填充到简历的section_position中
          try {
            customSectionId = await this.createCustomSection(null, '自定义模块');
            submodule_info.sections_position.push({
              type: 'custom',
              id: customSectionId,
              info_ids: []
            });
          } catch (error) {
            console.log(error);
          }
        } else {
          if (data.type === 'extras') {
            moduleInfo = {
              skill: {
                name: '技能',
                description: null
              },
              language: {
                name: '语言',
                description: null
              },
              other: {
                name: '活动',
                description: null
              },
              interest: {
                name: '兴趣',
                description: null
              },
              certificate: {
                name: '证书/执照',
                description: null
              }
            }
            this.$store.state.editor.extras = moduleInfo;
          } else {
            // this.$store.state.editor[data.type].push(moduleInfo)
          }
          //查找模块id
          // if (!window.location.href.includes('mentor')) {
            // 只有是自定义模块的话，才会给customSectionId赋值用于排序
            if (!baseField.includes(data.type) && data.type !== 'extras') {
              /**
               * 判断经历库中是否存在当前自定义模块的id
               * 1. 如果存在就直接set进section_position中
               * 2. 如果不存在就创建一个自定义模块
               */
              if (this.experienceList[data.type] && this.experienceList[data.type].length && !window.location.href.includes('mentor')) {
                customSectionId = this.experienceList[data.type][0].custom_section_id;
              } else {
                customSectionId = await this.createCustomSection(data.type, data[`${lang}_default_name`]);
              }
            }
          // }
          submodule_info.sections_position.push({
            type: data.type,
            id: customSectionId,
            info_ids: []
          })
        }
        if (customSectionId) {
          submodule_info.custom_sections_ids.push(customSectionId)
          // submodule_info.custom_sections_titles[`${customSectionId}_title`] = '自定义模块'
        }
        if (kind === null || kind === 'null') {
          this.updateCvDetail({
            submodule_info,
            operation_type: 'update_submodule_info'
          })
        } else {
          let cv = JSON.parse(JSON.stringify(this.cvDetail))
          cv.submodule_info = submodule_info
          this.createCvDetail({payload: cv})
        }

        // 整合已添加模块列表
        let obj = {
          id: customSectionId,
          info_ids: [],
          key: data.type,
          sections_position: {
            id: customSectionId,
            info_ids: [],
            type: data.type
          },
          title: data[`${lang}_default_name`],
          type: data.type,
        }
        let list = JSON.parse(JSON.stringify(this.listMenu))
        list.push(JSON.parse(JSON.stringify(obj)))
        this.setMenuList(list)
        let moduleList = JSON.parse(JSON.stringify(this.moduleList))
        if (data.type !== 'custom') {
          moduleList = moduleList.filter(item => item.type !== data.type)
        }
        //
        this.setFilterModule(moduleList)
        // this.setCurrentInfo({
        //   type: data.type,//works/edus模块类型
        //   data: moduleInfo, //当前编辑数据
        //   operation: 'module', //add/添加，edit/修改，module/增加大模块
        //   title: data[`${lang}_default_name`]
        // })
        // //关闭右侧tab
        // this.updateSidebarOption('');
        this.$nextTick(() => {
          const scrollEl = document.querySelector('.cvs-component')
          let moduleEls
          if (data.type === 'extras') {
            moduleEls = document.querySelectorAll('.extras')
          } else {
            moduleEls = document.querySelectorAll('.section-undefined')
          }
          if (moduleEls && moduleEls.length) {
            let { pageIndex, pageElHeight } = dealResumeDomScroll(moduleEls)
            this.$emit('dealCheckDomScroll', { pageIndex, pageElHeight })
            scrollEl.scrollTo({ top: moduleEls[0].offsetTop - 180, behavior: 'smooth' })
          }
        })
        // this.$store.commit('cvsEditor/editModuleData', editModuleData);
      },
      // 删除模块
      deleteModule(data, index) {
        console.log('delete', data, index);
        const alertData = {
          show: true,
          type: 'message',
          messageTitle: '删除提示',
          showCancelButton: true, //取消按钮
          showConfirmButton: true, // 确定按钮
          confirmButtonText: '取消',
          cancelButtonText: '删除',
          cancelButtonClass: 'cvs-edit-cancelButtonClass',
          confirmButtonClass: 'cvs-edit-confirmButtonClass',
          messageContent: `
          <p>删除内容将无法还原</p>
          <p style="color: #FF453E">确定要删除当前模块吗?</p>
        `,
          confirm: close => {
            close();
          },
          cancel: async close => {
            close();
            this.deleteModuleApi(data, index, close);
          }
        };
        this.$store.dispatch('app/setAlertData', alertData);
      },
      async deleteModuleApi(data, index, close) {
        let itemType = data.type ==='custom' ? data.id : data.type
        let cvDetail = JSON.parse(JSON.stringify(this.cvDetail));
        let { sections_position, custom_sections_ids } = cvDetail.submodule_info;
        let experienceList = JSON.parse(JSON.stringify(this.experienceList));

        //如果是作品集，删除当前简历全部id
        if(itemType === 'opus'){
          //执行删除模块id
          let deletelist = [];
          cvDetail.submodule_info[itemType+'_ids'].forEach(item=>{
            deletelist.push(api.cvsEditor.deleteOpus(item, {}, {cv_token: this.cvToken}))
          })
          if(deletelist.length){
            await Promise.all(deletelist)
          }
        }
        if (itemType === 'works') {
          this.updateCommonIndex(-1)
        }

        //整理简历模块选中状态及选中数据相关id
        if( itemType === 'works' || itemType === 'orgs' || itemType === 'edus' || itemType === 'opus' ){
          cvDetail.submodule_info[itemType+'_ids'] = [];
        }else if (itemType === 'extras'){
          this.extrasList.forEach(key=>{
            cvDetail.submodule_info[key+'_id'] = null;
          })
        }else {
          custom_sections_ids = custom_sections_ids.filter(item => item != data.id);
        }

        sections_position = sections_position.filter(item => item && !((item.type === 'custom' && item.id === data.id) || (item.type !== 'custom' && item.type === data.type)));
        cvDetail.submodule_info.sections_position = sections_position;
        cvDetail.submodule_info.custom_sections_ids = custom_sections_ids;

        if(cvDetail.basic_info.kind==='template' || cvDetail.basic_info.kind==='sample'){
          //整理经历库选中状态
          if(itemType === 'extras'){
            Object.keys(experienceList[itemType]).forEach(key=>{
              let item = experienceList[itemType][key];
              item.forEach(item=>{
                item.isSelect = false;
              })
            })
          }else{
            experienceList[itemType] && experienceList[itemType].forEach(item=>{
              item.isSelect = false;
            })
          }

          //同步简历信息到vuex中
          this.setCvDetail(cvDetail);

          //重新整理模块选中/未选中模块
          this.getMenuList();
          // // 整理当前模块管理选中数据
          // let listMenu = this.listMenu.filter(item=> !( item.id ==itemType || item.key ==itemType || item.type ==itemType ) )
          // this.listMenu = listMenu;
          // //同步已选模块数据
          // this.setMenuList(listMenu);
          // //更新未选择模块
          // this.getFilterModule();

          //清除vuex中当前简历选择的模块
          this.setModuleData({ type: itemType, info:[] })

          //清除经历库里选中的状态
          this.updateExperienceList(experienceList)
          this.updateBackUpExperienceList(experienceList)
          return false;
        }
        //更新简历
        try {
          let data = {
            operation_type:'update_submodule_info',
            submodule_info: cvDetail.submodule_info
          }
          let res = {}
          if (window.location.href.includes('mentor')) {
            res = await api.cvsEditor.updatedMentorCvInfo(this.cvToken, data)
          } else {
            res = await api.cvsEditor.updatedCvInfo(this.cvToken, data)
          }
          if(res.code === 1000){

            //整理经历库选中状态
            if(itemType === 'extras'){
              Object.keys(experienceList[itemType]).forEach(key=>{
                let item = experienceList[itemType][key];
                item.forEach(item=>{
                  item.isSelect = false;
                })
              })
            }else{
              experienceList[itemType] && experienceList[itemType].forEach(item=>{
                item.isSelect = false;
              })
            }
            console.log('deleteModuleApi=>>experienceList=>>>',experienceList)
            //同步简历信息到vuex中
            this.setCvDetail(cvDetail);

            //整理当前模块管理选中数据
            let listMenu = this.listMenu.filter(item=> !( item.id ===itemType || item.key ===itemType || item.type ===itemType ) )
            this.listMenu = listMenu;
            //同步已选模块数据
            this.setMenuList(listMenu);
            //更新未选择模块
            this.getFilterModule();

            //清除vuex中当前简历选择的模块
            this.setModuleData({ type: itemType, info:[] })

            //清除经历库里选中的状态
            this.updateExperienceList(experienceList)
            this.updateBackUpExperienceList(experienceList)

            this.$message.success('更新成功');
          }else{
            this.$message.error(res.message);
          }
        } catch (error) {
          console.log('error=>>',error)
          this.$message.error('更新失败');
        }

      },

      // 删除校徽
      deleteSchoolLogo() {
        const alertData = {
          show: true,
          type: 'message',
          messageTitle: '删除提示',
          showCancelButton: true, //取消按钮
          showConfirmButton: true, // 确定按钮
          confirmButtonText: '取消',
          cancelButtonText: '删除',
          cancelButtonClass: 'cvs-edit-cancelButtonClass',
          confirmButtonClass: 'cvs-edit-confirmButtonClass',
          messageContent: `
          <p>删除内容将无法还原</p>
          <p style="color: #FF453E">确定要删除校徽吗?</p>
        `,
          confirm: close => {
            close();
          },
          cancel: async close => {
            close();
            let cvDetail = JSON.parse(JSON.stringify(this.cvDetail));
            if(cvDetail.basic_info.kind==='template' || cvDetail.basic_info.kind==='sample'){
              //整理当前模块管理选中数据
              this.filterModule();

              //同步简历信息到vuex中
              cvDetail.basic_info.school_logo_url = null;
              cvDetail.basic_info.school_logo_id = null;
              //校徽信息同步到简历信息中
              this.setCvDetail(cvDetail);
              // //重新整理已选模块
              // this.getMenuList(cvDetail)
              //更新未选择模块
              this.getFilterModule();
              return false;
            }
            let res = await api.cvsEditor.deleteSchoolLogo(this.cvToken);
            if (res.code === 1000) {
              //整理当前模块管理选中数据

              //同步简历信息到vuex中
              cvDetail.basic_info.school_logo_url = null;
              cvDetail.basic_info.school_logo_id = null;
              //校徽信息同步到简历信息中
              this.setCvDetail(cvDetail);
              // //重新整理已选模块
              // this.getMenuList(cvDetail)
              //更新未选择模块
              this.getFilterModule();
            }
            else {
              this.$message.error(res.message);
            }
          }
        };
        this.$store.dispatch('app/setAlertData', alertData);
      },

      // 是否可恢复
      /*isRecover(data) {
        let removeList = this.removeList;
        for (let i = 0; i < removeList.length; i++) {
          if (data.type === removeList[i].type) return true;
        }
        return false;
      },
      // 恢复模块
      async recoverModule(data, index) {
        let cvInfo = JSON.parse(JSON.stringify(this.cvInfo));
        let removeList = JSON.parse(JSON.stringify(this.removeList));
        let moduleList = JSON.parse(JSON.stringify(this.moduleList));

        let { sections_position, custom_sections_ids } = cvInfo.submodule_info;
        let removeData = {};

        for (let i = removeList.length - 1; i >= 0; i--) {
          if (removeList[i].type === data.type) {
            removeData = removeList[i];
            removeList.splice(i, 1)
            break;
          }
        }
        sections_position.push(removeData.sections_position);
        if (removeData.type === 'custom') {
          custom_sections_ids.push(removeData.id);
          moduleList.splice(index, 1);
        }
        sections_position = sections_position.filter(item => !!item);
        cvInfo = {
          ...cvInfo,
          submodule_info: {
            ...cvInfo.submodule_info,
            sections_position,
            custom_sections_ids
          }
        };
        this.moduleList = moduleList;
        this.removeList = removeList;
        this.$store.commit('cvsEditor/setCvInfo', cvInfo);
        this.$store.dispatch('cvsEditor/updatedCvInfo', 'submodule_info');
      }*/
    },
  }
</script>
<style lang="scss" scoped>
  @import "~/assets/css/cvsEditModule";
  @import "manage";
  .flip-list-move {
    transition: transform 0.5s;
  }
  .no-move {
    transition: transform 0s;
  }
  .ghost {
    opacity: 0.5;
    background: #ececec;
  }
</style>
